import { PaymentMethodType } from '@core/store/payment/payment-state-models';

export const PaymentMethodTypeLocale = {
  [PaymentMethodType.default]: $localize`Default`,
  [PaymentMethodType.other]: $localize`Set Default`,
};
